export default __webpack_public_path__ + "static/media/Minit.c6b94c43.png";